module.exports = __webpack_public_path__ + "static/media/join.7d8dcd4a.mp3";